module.exports = __webpack_public_path__ + "img/LogoIberoHorizontal.516676d7.png";